module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.24133/images/default-avatar.png"